// Scope catalog for the API-key picker. Values MUST match the backend allowlist
// (src/features/platform/apiAccess/constants/scopes.js). Labels are German UI text.
// The public API is read-only.
export const API_SCOPE_OPTIONS = [
	{ value: 'leads:read', label: 'Leads & Suchlisten lesen' },
	{ value: 'stats:read', label: 'Kampagnen- & Post-Mailing-Statistiken lesen' },
];
